import React from 'react';
import { TriangleAlert as AlertTriangle } from 'lucide-react';
import './UnsavedChangesConfirm.css';

interface UnsavedChangesConfirmProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const UnsavedChangesConfirm: React.FC<UnsavedChangesConfirmProps> = ({ onConfirm, onCancel }) => (
  <div className="uc-confirm-overlay" onClick={onCancel}>
    <div className="uc-confirm-dialog" onClick={e => e.stopPropagation()}>
      <div className="uc-confirm-icon">
        <AlertTriangle size={28} color="#f59e0b" />
      </div>
      <h3 className="uc-confirm-title">Discard changes?</h3>
      <p className="uc-confirm-text">
        You have unsaved changes. Are you sure you want to close? Your input will be lost.
      </p>
      <div className="uc-confirm-actions">
        <button className="uc-confirm-cancel" onClick={onCancel}>
          Keep Editing
        </button>
        <button className="uc-confirm-discard" onClick={onConfirm}>
          Discard &amp; Close
        </button>
      </div>
    </div>
  </div>
);

export default UnsavedChangesConfirm;
